import React, { Component } from "react";
import { BynderWithSteps } from '../../BynderWithSteps/BynderWithSteps';
import SeniorenplatformItem from "../SeniorenplatformItem/SeniorenplatformItem";
import { SeniorenPlatformAccountMessage } from "../SeniorenplatformLoginPopup/SeniorenplatformAccount";
import { SeniorenplatformRelevantExercises } from "../SeniorenplatformRelevantExercises/SeniorenplatformRelevantExercises";
import { SeniorenplatformRelevantLeveledExercises } from "../SeniorenplatformRelevantLeveledExercises/SeniorenplatformRelevantLeveledExercises";

export default class Seniorenplatform extends Component {  
  constructor(props) {
    super();
    this.state = {
      index: 1,
      showSuppliesValue: false,
      relevantExercises: [],
      showLeveledExercisesComponent: true,
    };

    this.showSupplies = this.showSupplies.bind(this);
    this.isFavorite = this.isFavorite.bind(this);
  }

  showSupplies() {
    this.setState({ showSuppliesValue: !this.state.showSuppliesValue });
  }

  isFavorite() {
    return this.props.entries?.find(entry => entry.id === this.props.entry.id)?.isFavorite;
  }

  showLeveledExercisesComponent = (hasNextStep) => {
    this.setState({ showLeveledExercisesComponent: hasNextStep })
}

  render() {
    return (
      <div className="c-senioren__detail">
        <div className="c-senioren__detail__header">
          <h3>{this.props.entry.name}</h3>
          <button className={`c-senioren__button c-senioren__button--secondary ${this.isFavorite() ? "active" : ""}`} onClick={() => this.props.toggleIsFavorites(this.props.entry)}>
            <i className={`${this.isFavorite() ? "fas" : ""} fa-regular fa-heart`}></i>
            {
              this.isFavorite() ? this.props.dictionary.removeFavorite : this.props.dictionary.addFavorite
            }
          </button>
          <button className="c-senioren__button c-senioren__button--secondary mobile">
            <i className="fa-solid fa-share-nodes"></i>
          </button>
          <button className="c-senioren__button c-senioren__button--secondary mobile" onClick={() => this.props.toggleIsFavorites(this.props.entry)}>
            <i className="fa-regular fa-heart"></i>
          </button>
        </div>
        <div className="c-senioren__detail__content">
          <BynderWithSteps
            steps={this.props.entry.steps}
            bynderUrl={this.props.entry.video}
            dictionary={this.props.dictionary}
            showVideo={this.props.poId && this.props.poId !== ""}
            showStepsMobile={this.props.poId && this.props.poId !== ""} />

          {(!this.props.poId || this.props.poId === "")
            && <SeniorenPlatformAccountMessage id="msgDetail" dark={true} dictionary={this.props.dictionary} loginUrl={this.props.loginUrl} registerUrl={this.props.registerUrl} />
          }

        </div>
        <div className={`c-senioren__detail__utilities ${!this.props.poId || this.props.poId === "" ? "dn-mobile" : ""}`}>
          <h4 className="c-senioren__detail__utilities-title">
            {this.props.dictionary.benodigdheden}
          </h4>
          <div className="c-senioren__detail__utilities--mobile">
            <div
              className="c-senioren__detail__utilities--mobile-dropdown"
              onClick={this.showSupplies}
            >
              <span className="c-senioren__detail__utilities--mobile-title">
                {this.props.dictionary.benodigdheden}
              </span>
              <span className="c-senioren__detail__utilities--mobile-icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 12 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.3125 1.375L6.34375 5.875C6.15625 6.0625 5.875 6.0625 5.6875 5.875L0.65625 1.375C0.4375 1.1875 0.4375 0.875 0.625 0.6875C0.8125 0.46875 1.125 0.46875 1.3125 0.65625L6 4.84375L10.6562 0.65625C10.8438 0.46875 11.1562 0.46875 11.3438 0.6875C11.5312 0.875 11.5312 1.1875 11.3125 1.375Z"
                    fill="#0179C7"
                  />
                </svg>
              </span>
            </div>
            {this.state.showSuppliesValue !== false &&
              this.props.entry.equipment !== "" && (
                <div
                  className="c-senioren__detail__utilities--mobile-supplies"
                >

                  <ul>
                    {this.props.entry.equipment.map((equipment, index) => (
                      <li key={index}>{equipment}</li>
                    ))}
                  </ul>

                </div>
              )}
            {this.state.showSuppliesValue !== false &&
              this.props.entry.equipment === "" && (
                <div className="c-senioren__detail__utilities--mobile-supplies">
                  <ul>
                    <li>Er zijn geen benodigdheden voor deze oefening.</li>
                  </ul>
                </div>
              )}
          </div>
          {this.props.entry.equipment !== "" &&
            this.props.entry.equipment !== null && (
              <div
                className="c-senioren__detail__utilities__supplies">
                <ul>
                  {this.props.entry.equipment.map((equipment, index) => (
                    <li key={index}>{equipment}</li>
                  ))}
                </ul>
              </div>
            )}
          {this.props.entry.equipment === "" || this.props.entry.equipment === null && (
            <div className="c-senioren__detail__utilities__supplies">
              <ul>
                <li>Er zijn geen benodigdheden voor deze oefening.</li>
              </ul>
            </div>
          )}
        </div>
        {!this.props.entry.exerciseGroup && this.props.entry.difficultyLevel <= 0 && (
          <SeniorenplatformRelevantExercises
            toggleIsFavorites={this.props.toggleIsFavorites}
            getDetailsOfItem={this.props.getDetailsOfItem}
            dictionary={this.props.dictionary}
            entry={this.props.entry}
            poId={this.props.poId}
            entries={this.props.entries}
            />
        )}
        {this.props.entry.exerciseGroup && this.props.entry.difficultyLevel > 0 && this.state.showLeveledExercisesComponent && (
            <SeniorenplatformRelevantLeveledExercises
              toggleIsFavorites={this.props.toggleIsFavorites}
              getDetailsOfItem={this.props.getDetailsOfItem}
              dictionary={this.props.dictionary}
              entry={this.props.entry}
              poId={this.props.poId}
              entries={this.props.entries}
              updateShowLeveledExercisesComponent={this.showLeveledExercisesComponent}
            />
        )}       

        <div className="c-senioren__detail__back">
          <a className="c-link" onClick={() => this.props.getDetailsOfItem(null)}>
            <i className="fa-solid fa-arrow-left"></i> {this.props.dictionary.backToOverview}
          </a>
        </div>

      </div>
    )
  }
}